
<qrcode [qrdata]="data" [width]="width" [margin]="1" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>